<template>
  <div>
    <head>
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
      <div id="layout-wrapper">
        <NavigationBar />

        <div id="content" class="content-minimize">
          <div class="page-content">
            <div class="container-fluid">
              <!-- Page Title -->
              <div class="row">
                <div class="col-12">
                  <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">Patient Registry</h4>
                    <div class="page-title-right">
                      <ol class="breadcrumb m-0">
                        <li class="breadcrumb-item"><a href="javascript: void(0);">Hospital</a></li>
                        <li class="breadcrumb-item active">Patients</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Stats Cards -->
              <div class="row mb-4">
                <div class="col-xl-3 col-md-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Total Patients</p>
                          <h4 class="mb-0">{{ numberFormat(stats.total) }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                            <span class="avatar-title"><i class="mdi mdi-account-group font-size-24"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Male</p>
                          <h4 class="mb-0">{{ numberFormat(stats.male) }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                            <span class="avatar-title bg-info"><i class="mdi mdi-gender-male font-size-24"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Female</p>
                          <h4 class="mb-0">{{ numberFormat(stats.female) }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-pink">
                            <span class="avatar-title bg-pink"><i class="mdi mdi-gender-female font-size-24"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-md-6">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Today</p>
                          <h4 class="mb-0">{{ numberFormat(stats.today) }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                            <span class="avatar-title bg-success"><i class="mdi mdi-calendar-today font-size-24"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Filters Card -->
              <div class="card mb-4">
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-md-4">
                      <div class="input-group">
                        <span class="input-group-text"><i class="mdi mdi-magnify"></i></span>
                        <input type="text" class="form-control" v-model="filters.search" placeholder="Search by name, ID, phone...">
                        <span v-if="filters.search" class="input-group-text" style="cursor: pointer;" @click="filters.search = ''"><i class="mdi mdi-close"></i></span>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <select class="form-select" v-model="filters.gender" @change="applyFilters">
                        <option value="">All Genders</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <select class="form-select" v-model="filters.ageGroup" @change="applyFilters">
                        <option value="">All Ages</option>
                        <option value="Infant">Infant (0-1)</option>
                        <option value="Child">Child (1-12)</option>
                        <option value="Adolescent">Adolescent (13-19)</option>
                        <option value="Adult">Adult (20-59)</option>
                        <option value="Elderly">Elderly (60+)</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <select class="form-select" v-model="filters.status" @change="applyFilters">
                        <option value="">All Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                        <option value="Deceased">Deceased</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <button class="btn btn-outline-secondary w-100" @click="resetFilters"><i class="mdi mdi-filter-remove me-1"></i> Clear Filters</button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Patient Table -->
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <span>Showing <strong>{{ paginationStart }}-{{ paginationEnd }}</strong> of <strong>{{ numberFormat(totalCount) }}</strong> patients</span>
                  <div class="d-flex align-items-center gap-3">
                    <div class="d-flex align-items-center gap-2">
                      <label class="small text-muted mb-0">Per page:</label>
                      <select class="form-select form-select-sm" style="width: 80px;" v-model="perPage" @change="loadPatients">
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                      </select>
                    </div>
                    <button class="btn btn-success btn-sm" @click="goTo('patient-register')"><i class="mdi mdi-account-plus me-1"></i> Register Patient</button>
                  </div>
                </div>

                <div class="card-body p-0">
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3"></div>
                    <p class="text-muted">Loading patients...</p>
                  </div>

                  <div v-else-if="patients.length === 0" class="text-center py-5">
                    <div class="avatar-lg mx-auto mb-4">
                      <span class="avatar-title bg-light text-muted rounded-circle"><i class="mdi mdi-account-group font-size-48"></i></span>
                    </div>
                    <h5 class="text-muted">No patients found</h5>
                    <p class="text-muted">Try adjusting your filters or register a new patient</p>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-light">
                        <tr>
                          <th @click="sortBy('fullNames')" style="cursor: pointer;">Patient Name <i class="mdi" :class="getSortIcon('fullNames')"></i></th>
                          <th @click="sortBy('patientID')" style="cursor: pointer;">Patient ID <i class="mdi" :class="getSortIcon('patientID')"></i></th>
                          <th>ID Number</th>
                          <th>Phone</th>
                          <th @click="sortBy('age')" style="cursor: pointer;">Age/Gender <i class="mdi" :class="getSortIcon('age')"></i></th>
                          <th>Location</th>
                          <th @click="sortBy('dateCreated')" style="cursor: pointer;">Registered <i class="mdi" :class="getSortIcon('dateCreated')"></i></th>
                          <th>Status</th>
                          <th class="text-end">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="patient in patients" :key="patient.patientID">
                          <td>
                            <div class="d-flex align-items-center">
                              <div class="avatar-sm me-3">
                                <span class="avatar-title rounded-circle" :class="patient.gender === 'Male' ? 'bg-primary-subtle text-primary' : 'bg-pink-subtle text-pink'">{{ getInitials(patient.fullNames) }}</span>
                              </div>
                              <div>
                                <h6 class="mb-0">{{ patient.fullNames }}</h6>
                                <span v-if="patient.allergies" class="badge bg-danger-subtle text-danger"><i class="mdi mdi-alert me-1"></i>Allergies</span>
                              </div>
                            </div>
                          </td>
                          <td><code class="text-primary">{{ patient.patientID }}</code></td>
                          <td>{{ patient.idNo || '-' }}</td>
                          <td><a v-if="patient.phoneNumber" :href="'tel:' + patient.phoneNumber">{{ patient.phoneNumber }}</a><span v-else>-</span></td>
                          <td>
                            <span class="badge" :class="patient.gender === 'Male' ? 'bg-primary' : 'bg-pink'">{{ patient.gender }}</span>
                            <span class="ms-1">{{ patient.age }} yrs</span>
                          </td>
                          <td><small>{{ patient.county || patient.subCountyName || '-' }}</small></td>
                          <td><small class="text-muted">{{ formatDate(patient.dateCreated) }}</small></td>
                          <td>
                            <span class="badge" :class="{'bg-success': patient.status === 'Active', 'bg-secondary': patient.status === 'Inactive', 'bg-dark': patient.status === 'Deceased'}">{{ patient.status }}</span>
                          </td>
                          <td class="text-end">
                            <div class="btn-group btn-group-sm">
                              <button class="btn btn-soft-primary" @click="viewPatient(patient)" title="View"><i class="mdi mdi-eye"></i></button>
                              <button class="btn btn-soft-success" @click="createVisit(patient)" title="Visit"><i class="mdi mdi-calendar-plus"></i></button>
                              <button class="btn btn-soft-secondary" @click="editPatient(patient)" title="Edit"><i class="mdi mdi-pencil"></i></button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card-footer bg-white" v-if="totalPages > 1">
                  <nav>
                    <ul class="pagination justify-content-center mb-0">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="#" @click.prevent="goToPage(1)"><i class="mdi mdi-chevron-double-left"></i></a>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="#" @click.prevent="goToPage(currentPage - 1)"><i class="mdi mdi-chevron-left"></i></a>
                      </li>
                      <li v-for="page in visiblePages" :key="page" class="page-item" :class="{ active: page === currentPage }">
                        <a class="page-link" href="#" @click.prevent="goToPage(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <a class="page-link" href="#" @click.prevent="goToPage(currentPage + 1)"><i class="mdi mdi-chevron-right"></i></a>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <a class="page-link" href="#" @click.prevent="goToPage(totalPages)"><i class="mdi mdi-chevron-double-right"></i></a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>

            </div>
          </div>

          <footer class="footer">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-6"></div>
                <div class="col-sm-6">
                  <div class="text-sm-end d-sm-block">County Hospital Management System</div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { execute, hospital } from "@/api";

export default {
  name: "PatientList",
  components: { NavigationBar },

  data() {
    return {
      loading: false,
      patients: [],
      totalCount: 0,
      currentPage: 1,
      perPage: 25,
      sortField: 'dateCreated',
      sortOrder: 'desc',
      filters: { search: '', gender: '', ageGroup: '', status: '' },
      stats: { total: 0, male: 0, female: 0, today: 0 },
      searchTimeout: null
    };
  },

  computed: {
    totalPages() { return Math.ceil(this.totalCount / this.perPage); },
    visiblePages() {
      const pages = [];
      const start = Math.max(1, this.currentPage - 2);
      const end = Math.min(this.totalPages, this.currentPage + 2);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },
    paginationStart() { return (this.currentPage - 1) * this.perPage + 1; },
    paginationEnd() { return Math.min(this.currentPage * this.perPage, this.totalCount); }
  },

  mounted() { this.loadPatients(); this.loadStats(); },

  watch: {
    'filters.search'(val) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.loadPatients();
      }, 300);
    }
  },

  beforeUnmount() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
  },

  methods: {
    goTo(route) { this.$router.push('/' + route); },
    numberFormat(num) { return new Intl.NumberFormat("en-GB").format(num || 0); },

    loadPatients() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getPatients");
      data.append("page", this.currentPage);
      data.append("limit", this.perPage);
      data.append("sortField", this.sortField);
      data.append("sortOrder", this.sortOrder);
      Object.keys(this.filters).forEach(key => data.append(key, this.filters[key]));
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, hospital).then((res) => {
        this.loading = false;
        if (res.data.success) {
          this.patients = res.data.data.patients || [];
          this.totalCount = res.data.data.count?.total || res.data.data.patients?.length || 0;
        } else { this.patients = []; this.totalCount = 0; }
      }).catch((e) => { this.loading = false; this.patients = []; console.error('Error:', e); });
    },

    loadStats() {
      const data = new FormData();
      data.append("function", "getPatientStats");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, hospital).then((res) => {
        if (res.data.success && res.data.data.stats) this.stats = res.data.data.stats;
      }).catch(e => console.error('Error:', e));
    },

    applyFilters() { this.currentPage = 1; this.loadPatients(); },
    resetFilters() { 
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.filters = { search: '', gender: '', ageGroup: '', status: '' }; 
      this.currentPage = 1; 
      this.loadPatients(); 
    },

    sortBy(field) {
      if (this.sortField === field) this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      else { this.sortField = field; this.sortOrder = 'asc'; }
      this.loadPatients();
    },

    getSortIcon(field) {
      if (this.sortField !== field) return 'mdi-arrow-up-down text-muted';
      return this.sortOrder === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down';
    },

    goToPage(page) { if (page >= 1 && page <= this.totalPages && page !== this.currentPage) { this.currentPage = page; this.loadPatients(); } },
    viewPatient(patient) { this.$router.push('/patient-profile/' + patient.patientID); },
    editPatient(patient) { this.$router.push('/patient-edit/' + patient.patientID); },
    createVisit(patient) { this.$router.push('/new-visit?patientID=' + patient.patientID); },

    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    getInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
    }
  }
}
</script>

<style scoped>
.mini-stats-wid .card-body { padding: 20px; }
.mini-stat-icon { width: 48px; height: 48px; }
.avatar-sm { width: 2.5rem; height: 2.5rem; }
.avatar-lg { width: 5rem; height: 5rem; }
.avatar-title { display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; color: #fff; font-weight: 600; }
.bg-primary-subtle { background-color: rgba(85, 110, 230, 0.1); }
.bg-pink-subtle { background-color: rgba(232, 62, 140, 0.1); }
.bg-danger-subtle { background-color: rgba(244, 106, 106, 0.1); }
.bg-pink { background-color: #e83e8c !important; }
.text-pink { color: #e83e8c !important; }
.btn-soft-primary { background-color: rgba(85, 110, 230, 0.1); color: #556ee6; border: none; }
.btn-soft-primary:hover { background-color: #556ee6; color: #fff; }
.btn-soft-success { background-color: rgba(52, 195, 143, 0.1); color: #34c38f; border: none; }
.btn-soft-success:hover { background-color: #34c38f; color: #fff; }
.btn-soft-secondary { background-color: rgba(116, 120, 141, 0.1); color: #74788d; border: none; }
.btn-soft-secondary:hover { background-color: #74788d; color: #fff; }
.table th { white-space: nowrap; font-weight: 600; font-size: 0.85rem; }
.page-link { min-width: 40px; text-align: center; }
</style>
